<template>
  <div class="relative w-full md:w-1/2 lg:w-1/4 mt-8">
    <iframe
      class="w-full min-h-screen-50 border-2 border-gray-600 rounded shadow-lg mt-4 max-h-lg"
      @load="loaded"
      src="about:blank"
      ref="iframe"
    ></iframe>
    <div
      class="absolute top-0 left-0 right-0 h-12 rounded mx-6 bg-white shadow -mt-4 border-8 border-white bg-center bg-no-repeat bg-contain"
      :style="{ backgroundImage: `url('${logo}')` }"
    ></div>
    <div
      class="shadow-inner p-2 mt-2 border border-gray-200 rounded bg-white text-center font-mono"
    >
      {{ time(counter) }}
    </div>
    <div
      class="absolute top-0 left-0 right-0 bottom-0 rounded bg-transparent flex items-center justify-center text-blue-500 text-5xl"
    >
      <div v-if="start !== null && !complete">
        <pulse-loader color="#4299E1"></pulse-loader>
      </div>
      <div v-else-if="start == null && !complete">
        <watch-icon></watch-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { WatchIcon } from "vue-feather-icons";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "Frame",
  props: {
    logo: String,
    url: String
  },
  components: {
    WatchIcon,
    PulseLoader
  },
  data() {
    return {
      start: null,
      counter: 0,
      complete: false
    };
  },
  computed: {
    src: function() {
      return this.url + "?benchmark=" + this.start;
    }
  },
  methods: {
    go() {
      this.start = Date.now();
      this.increment();
      this.$refs.iframe.src = this.src;
    },
    increment() {
      if (!this.complete) {
        setTimeout(() => {
          this.counter = this.counter + 10;
          this.increment();
        }, 10);
      }
    },
    loaded() {
      if (this.start !== null) {
        this.complete = true;
        this.$emit("finished", true);
      }
    },
    time(ms) {
      return new Date(ms).toISOString().slice(11, -1);
    }
  }
};
</script>
